<form [formGroup]="userInfoForm">
    <div class="hvac-user-validation-form-container">
        <h2 class="hvac-user-validation-form-title">{{ 'USER_VALIDATION.PROFILE' | translate}}</h2>
        <div class="hvac-user-validation-input-container">
            <div class="hvac-user-validation-input-form-column">
                <utc-input [label]="'GENERAL.LABELS.USER_ID' | translate" type="text"
                    [inputControl]="userInfoForm.controls.userIdControl" [disabledInput]="true"></utc-input>
                <utc-input [label]="'GENERAL.LABELS.MY_HVAC_PIN' | translate"
                    [inputControl]="userInfoForm.controls.myHvacPinControl" type="text" [disabledInput]="true">
                </utc-input>
                <utc-input [label]="'GENERAL.LABELS.EMPLOYER_ID' | translate"
                    [inputControl]="userInfoForm.controls.employeeIdControl" type="text" [disabledInput]="true">
                </utc-input>
                <utc-input [label]="'GENERAL.LABELS.EMPLOYER_NAME' | translate"
                    [inputControl]="userInfoForm.controls.employeeNameControl" type="text" [disabledInput]="true">
                </utc-input>
                <utc-input [label]="'GENERAL.LABELS.USER_NAME' | translate"
                    [inputControl]="userInfoForm.controls.usernameControl" type="text" [disabledInput]="true">
                </utc-input>
                <utc-input
                    [error]="userInfoForm.controls.firstNameControl.touched && !userInfoForm.controls.firstNameControl.valid"
                    [errorMessage]="firstNameErrorMessage$ | async"
                    [inputControl]="userInfoForm.controls.firstNameControl" inputId="user-validation-input"
                    [label]="'GENERAL.LABELS.FIRST_NAME' | translate" type="text" [max]="40"></utc-input>
                <utc-input
                    [error]="userInfoForm.controls.lastNameControl.touched && !userInfoForm.controls.lastNameControl.valid"
                    [errorMessage]="lastNameErrorMessage$ | async"
                    [inputControl]="userInfoForm.controls.lastNameControl" inputId="user-validation-input"
                    [label]="'GENERAL.LABELS.LAST_NAME' | translate" type="text" [max]="40"></utc-input>
            </div>
            <span class="vertical-spacer"></span>
            <div class="hvac-user-validation-input-form-column">
                <utc-input
                    [error]="userInfoForm.controls.address1Control.touched && !userInfoForm.controls.address1Control.valid"
                    [errorMessage]="addressErrorMessage$ | async" [inputControl]="userInfoForm.controls.address1Control"
                    inputId="user-validation-input" [label]="'GENERAL.LABELS.ADDRESS_1' | translate" type="text" [max]="60">
                </utc-input>
                <utc-input [inputControl]="userInfoForm.controls.address2Control" inputId="user-validation-input"
                    [error]="userInfoForm.controls.address2Control.touched && !userInfoForm.controls.address2Control.valid"
                    [label]="'GENERAL.LABELS.ADDRESS_2' | translate" type="text" [max]="60"></utc-input>
                <utc-input [error]="userInfoForm.controls.cityControl.touched && !userInfoForm.controls.cityControl.valid"
                    [errorMessage]="cityErrorMessage$ | async" [inputControl]="userInfoForm.controls.cityControl"
                    inputId="user-validation-input" [label]="'GENERAL.LABELS.CITY' | translate" type="text" [max]="40">
                </utc-input>

                <utc-select [group]="userInfoForm" control="countryControl"
                    [selectId]="'selectcountry'"
                    [error]="userInfoForm.controls.countryControl.touched && !userInfoForm.controls.countryControl.valid"
                    [defaultOption]="'GENERAL.LABELS.COUNTRY' | translate"
                    [options]="(countryOptionData$ | async)!">
                </utc-select>

                <utc-select [group]="userInfoForm" control="stateControl"
                    [selectId]="'selectState'"
                    [error]="userInfoForm.controls.stateControl.touched && !userInfoForm.controls.stateControl.valid"
                    [defaultOption]="'GENERAL.LABELS.STATE' | translate"
                    [options]="(stateOptionData | async)!">
                </utc-select>

                <utc-input [error]="userInfoForm.controls.zipControl.touched && !userInfoForm.controls.zipControl.valid"
                    (input)="onPostalCodeInput($event)" [max]="10"
                    [placeholder]="(placeHolderByCountry$ | async)?.placeHolderZipcode?.label || 'USER_ADMIN.PLACEHOLDER_TEXT.ZIP_CODE' | translate"
                    [errorMessage]="zipCodeErrorMessage$ | async" [inputControl]="userInfoForm.controls.zipControl"
                    inputId="user-validation-input" type="text">
                </utc-input>
            </div>
            <span class="vertical-spacer"></span>
            <div class="hvac-user-validation-input-form-column">
                <utc-input inputId="office_number" [mask]="maskPhoneNumber" [error]="userInfoForm.controls.phoneControl.touched && !userInfoForm.controls.phoneControl.valid" [inputControl]="userInfoForm.controls.phoneControl"
                    [label]="'GENERAL.LABELS.PHONE' | translate" (input)="onPhoneInput($event, 'phoneControl')" type="text" [max]="maskPhoneNumber ? 14:20"></utc-input>
                <utc-input inputId="mobile_number" [error]="userInfoForm.controls.cellControl.touched && !userInfoForm.controls.cellControl.valid" [mask]="maskPhoneNumber" [inputControl]="userInfoForm.controls.cellControl"
                    [label]="'GENERAL.LABELS.CELL_PHONE' | translate" (input)="onPhoneInput($event, 'cellControl')" type="text" [max]="maskPhoneNumber ? 14:20"></utc-input>
                <utc-input inputId="fax_number" [mask]="maskPhoneNumber" [error]="userInfoForm.controls.faxControl.touched && !userInfoForm.controls.faxControl.valid" [inputControl]="userInfoForm.controls.faxControl" 
                    [label]="'GENERAL.LABELS.FAX' | translate" (input)="onPhoneInput($event, 'faxControl')" type="text" [max]="maskPhoneNumber ? 14:20"></utc-input>
                <utc-input
                    [error]="userInfoForm.controls.emailControl.touched && !userInfoForm.controls.emailControl.valid"
                    [errorMessage]="emailErrorMessage$ | async" [inputControl]="userInfoForm.controls.emailControl"
                    inputId="user-validation-input" [label]="'GENERAL.LABELS.EMAIL' | translate" type="text" [max]="241">
                </utc-input>
            </div>
        </div>
    </div>
    <div class='hvac-user-validation-input-row'>
        <utc-checkbox inputId="user-validation-input-terms" inputName="user-validation-input-terms"
            (change)="changeTermsControl($event)">
        </utc-checkbox>
        <p class='user-validation-input-terms-checkbox-terms-link'>{{ 'GENERAL.TEXT.TERMS_AND_CONDITIONS' | translate
            }}
            <a target='_blank' hvacLink='primary' [href]="'FOOTER.TERMS_OF_USE_LINK' | translate"
                class='user-validation-policy-link'>{{'GENERAL.TEXT.TERMS_OF_USE' | translate}}</a>
            {{ 'GENERAL.TEXT.AND' | translate
            }}
            <a target='_blank' hvacLink='primary' [href]="'FOOTER.PRIVACY_POLICY_LINK' | translate"
                class='user-validation-policy-link'>{{'GENERAL.TEXT.PRIVACY_POLICY' | translate}}</a>
        </p>
    </div>
</form>
<hvac-email-validation *ngIf="enableEmailVerification$ | async" [requestEmail]="userInfoForm.controls.emailControl.value" (emailVerification)="emailVerification($event)" (cancel)="cancelValidation($event)"></hvac-email-validation>

